module.exports = __webpack_public_path__ + "static/media/Iconkyc.956dfec3.svg";